/**
 * Formats money and dates using the admin-configured country / currency / timezone / locale.
 */

function storedRegion() {
  try {
    const raw = localStorage.getItem('currencyPreference');
    if (!raw) return {};
    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
}

/**
 * @param {number|string|null} amount
 * @param {string} currencyCode
 * @param {object} [options]
 * @param {string} [options.locale]
 */
export function formatAmount(amount, currencyCode, options = {}) {
  if (amount === null || amount === undefined) return '—';

  const num = typeof amount === 'number' ? amount : parseFloat(amount);
  if (isNaN(num)) return '—';

  const stored = storedRegion();
  const code = currencyCode || stored.currency || 'KES';
  const locale = options.locale || stored.locale || 'en-KE';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: options.minimumFractionDigits ?? 0,
      maximumFractionDigits: options.maximumFractionDigits ?? 2,
    }).format(num);
  } catch {
    return `${code} ${num.toLocaleString(locale)}`;
  }
}

/**
 * @param {string|Date|null} value
 * @param {object} [ctx]  { locale, timezone }
 * @param {object} [options] Intl date options
 */
export function formatDate(value, ctx = {}, options = {}) {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  const stored = storedRegion();
  const locale = ctx.locale || stored.locale || 'en-KE';
  const timeZone = ctx.timezone || stored.timezone || 'Africa/Nairobi';
  const opts = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...options,
    timeZone,
  };
  try {
    return new Intl.DateTimeFormat(locale, opts).format(d);
  } catch {
    return d.toLocaleDateString();
  }
}

export function formatDateTime(value, ctx = {}) {
  return formatDate(value, ctx, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatShortDate(value, ctx = {}) {
  return formatDate(value, ctx, { day: 'numeric', month: 'short', year: '2-digit' });
}
